module.exports = {
  nonRespDashboardEvents: {
    Dashboard: {
      code: 'Dashboard',
      events: {
        Load: {
          description: 'Triggered when the non RESP dashboard is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'Non_RESP_Dashboard_Loaded'
          },
          ga: {
            action: 'Non_RESP_Dashboard_Loaded'
          }
        },
        CtaClick: {
          description: 'Triggered when a CTA button is clicked on the non RESP dashboard.',
          eventHub: {
            code: 'OnClickCta',
            action: 'Non_RESP_[$.action]CTA_Clicked'
          },
          ga: {
            action: 'Non_RESP_[$.action]CTA_Clicked'
          }
        },
        ModalLinkClick: {
          description: 'Triggered when a modal link is clicked on the non RESP dashboard.',
          eventHub: {
            code: 'OnClickModalLink',
            action: 'Non_RESP_Modal_[$.type]Link_Clicked'
          },
          ga: {
            action: 'Non_RESP_Modal_[$.type]Link_Clicked'
          }
        }
      }
    },
    ChildSavingsCalculatorFilters: {
      code: 'ChildSavingsCalculatorFilters',
      events: {
        Select: {
          description: 'Triggered when an option is selected on the savings calculator.',
          eventHub: {
            code: 'OnSelect',
            action: 'Non_RESP_Calculator_[$.field]Selected'
          },
          ga: {
            action: 'Non_RESP_Calculator_[$.field]Selected'
          }
        }
      }
    },
    Money: {
      code: 'Money',
      events: {
        CardClick: {
          description: 'Triggered when a card is clicked on the Money page.',
          eventHub: {
            code: 'OnCardClick',
            action: 'Non_RESP_Money_[$.action]_Clicked'
          },
          ga: {
            action: 'Non_RESP_Money_[$.action]_Clicked'
          }
        }
      }
    },
    Rewards: {
      code: 'Rewards',
      events: {
        DetailsClick: {
          description: 'Triggered when a "See details" button is clicked on the offers page.',
          eventHub: {
            code: 'OnClickDetails',
            action: 'Non_RESP_Rewards_[$.action]_Clicked'
          },
          ga: {
            action: 'Non_RESP_Rewards_[$.action]_Clicked'
          }
        },
        OfferClick: {
          description: 'Triggered when an offer card is clicked on the offers page.',
          eventHub: {
            code: 'OnClickOffer',
            action: 'Non_RESP_Rewards_Offer_Clicked',
            dataKeys: ['partner']
          },
          ga: {
            action: 'Non_RESP_Rewards_Offer_Clicked'
          }
        }
      }
    },
    Settings: {
      code: 'Settings',
      events: {
        PersonalInfoClick: {
          description: 'Triggered when the "Personal information" card is clicked on the settings page.',
          eventHub: {
            code: 'OnClickPersonalInfo',
            action: 'Non_RESP_Settings_PersonalInfo_Clicked'
          },
          ga: {
            action: 'Non_RESP_Settings_PersonalInfo_Clicked'
          }
        }
      }
    },
    Tools: {
      code: 'TOOLS',
      events: {
        Load: {
          description: 'Triggered on Tools page load',
          eventHub: {
            code: 'LOAD',
            action: 'Tools_Page loaded'
          }
        },
        InterestQuiz: {
          description: 'Triggered when use clicks on Interest Quiz card.',
          eventHub: {
            code: 'IQ',
            action: 'Tools_Clicked Interest Quiz'
          }
        },
        CareerMatcher: {
          description: 'Triggered when user clicks on Career Matcher card.',
          eventHub: {
            code: 'CSM',
            action: 'Tools_Clicked Career and School Matcher'
          }
        },
        Gifting: {
          description: 'Triggered when user clicks on Gifting card.',
          eventHub: {
            code: 'GIFT',
            action: 'Tools_Clicked Gifting'
          }
        },
        CostOfSchool: {
          description: 'Triggered when user clicks on Cost of School card.',
          eventHub: {
            code: 'COS',
            action: 'Tools_Clicked Cost of School'
          }
        },
        Scholarship: {
          description: 'Triggered when user clicks on Scholarship card.',
          eventHub: {
            code: 'SCHOLARSHIP',
            action: 'Tools_Clicked Scholarships'
          }
        },
        Contributions: {
          description: 'Triggered when user clicks on Contributions card.',
          eventHub: {
            code: 'CONTRIBUTION',
            action: 'Tools_Clicked Schedule contributions'
          }
        }
      }
    },
    PrenatalDashboard: {
      code: 'PrenatalDashboard',
      events: {
        ContinueClick: {
          description: 'Triggered when the "Continue" CTA button is clicked on the pedning application card.',
          eventHub: {
            code: 'OnClickContinue',
            action: 'Non-RESP Dashboard_Clicked Continue Expecting Parent Application'
          }
        },
        AddDueDateClick: {
          description: 'Triggered when the "Add Due Date" CTA button is clicked on the expecting parent due date card.',
          eventHub: {
            code: 'OnClickAddDueDate',
            action: 'Non-RESP Dashboard_Clicked Add Due Date'
          }
        }
      }
    }
  }
};
